export default {
  default: {
    quoteTotal: 'Quote Total',
  },
}
